import $ from '@node_modules/jquery'
window.$ = window.jQuery = $